<template>
  <div style="display:none" ref="printArea">
    <div v-if="data.company != ''">
      <ul>
        <li v-if="data.company.fantasy_name != null">
          <h2 class="company-name">{{ data.company.fantasy_name}}</h2>
        </li>
        <li>
          <h2 class="company-name" v-if="!(data.company.fantasy_name != null)">
            {{ data.company.name}}
          </h2>
          <p v-else>
              {{ data.company.name}}
          </p>
        </li>
        <li>Descripción: {{ data.company.description}}</li>
        <li>{{ identification_type_letters }}: {{ data.company.identification}}</li>
        <li>Teléfono: {{ data.company.phone}}</li>
        <li>Email: {{ data.company.email}}</li>
        <li>Dirección: {{ data.company.other_signs }}</li>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Apertura</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Monto de apertura
              </td>
              <td align="right">
                <calc-price :price="data.openBox.amount"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Efectivo</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.cashInvoices" :key="item.id">
              <td>
                Fact {{ item.reference }}
              </td>
              <td align="right">
                <calc-price :price="item.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total
              </td>
              <td align="right">
                <calc-price :price="data.cash"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Tarjetas</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.cardInvoices" :key="item.id">
              <td>
                Fact {{ item.reference }}
              </td>
              <td align="right">
                <calc-price :price="item.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total
              </td>
              <td align="right">
                <calc-price :price="data.card"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Transferencias</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.depositInvoices" :key="item.id">
              <td>
                Fact {{ item.reference }}
              </td>
              <td align="right">
                <calc-price :price="item.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total
              </td>
              <td align="right">
                <calc-price :price="data.deposit"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Cheques</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.checkInvoices" :key="item.id">
              <td>
                Fact {{ item.reference }}
              </td>
              <td align="right">
                <calc-price :price="item.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total
              </td>
              <td align="right">
                <calc-price :price="data.check"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Terceros</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.thirdInvoices" :key="item.id">
              <td>
                Fact {{ item.reference }}
              </td>
              <td align="right">
                <calc-price :price="item.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total
              </td>
              <td align="right">
                <calc-price :price="data.third"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Otros</h3>
        </li>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.otherInvoices" :key="item.id">
              <td>
                Fact {{ item.reference }}
              </td>
              <td align="right">
                <calc-price :price="item.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total
              </td>
              <td align="right">
                <calc-price :price="data.other"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
      <ul>
        <li>
          <h3 class="company-name">Total Ventas</h3>
        </li>
        <br>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Efectivo
              </td>
              <td align="right">
                <calc-price :price="data.cash"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Tarjeta
              </td>
              <td align="right">
                <calc-price :price="data.card"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Transferencia
              </td>
              <td align="right">
                <calc-price :price="data.deposit"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Cheque
              </td>
              <td align="right">
                <calc-price :price="data.check"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Tercero
              </td>
              <td align="right">
                <calc-price :price="data.third"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Otro
              </td>
              <td align="right">
                <calc-price :price="data.other"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total de créditos
              </td>
              <td align="right">
                <calc-price :price="data.credit"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Total de ingresos
              </td>
              <td align="right">
                <calc-price :price="data.total"
                  :currency="data.currency"
                  :fractionCount="2"
                  :exchange_rate="0">
                </calc-price>
              </td>
            </tr>
          </tbody>
        </table>
      </ul>
    </div>
      
       

            <!-- <div class="print-totals">
            <p>
              Subtotal:
              <calc-price :price="transaction.subtotal"
                :currency="transaction.currency_id"
                :exchange_rate="transaction.exchange_rate">
              </calc-price>
            </p>
            <p>
              Descuento:
              <calc-price :price="transaction.discount"
                :currency="transaction.currency_id"
                :exchange_rate="transaction.exchange_rate">
              </calc-price>
            </p>
            <p>
              IVA:
              <calc-price :price="transaction.tax"
                :currency="transaction.currency_id"
                :exchange_rate="transaction.exchange_rate">
              </calc-price>
            </p>
            <p v-if="transaction.iva_devuelto > 0">
              IVA Devuelto:
             <calc-price :price="transaction.iva_devuelto"
                :currency="transaction.currency_id"
                :exchange_rate="transaction.exchange_rate">
              </calc-price>
            </p>
            <p>
              
              Total:
              <calc-price :price="transaction.total - transaction.iva_devuelto"
                :currency="transaction.currency_id"
                :exchange_rate="transaction.exchange_rate">
              </calc-price>
            </p>
          </div>

          <div>
            <p class="key50digits">
              <b>Clave:</b> {{ transaction.key50digits }}
            </p>
          </div>

          <div v-if="transaction.comment">
            <p class="key50digits">
              <b>Nota:</b> {{ transaction.comment }}
            </p>
          </div>

          <div class="resolution">
            <p>Autorizada mediante resolucion DGT-R-033-2019 del 20 de junio de 2019 version 4.3</p>
          </div> -->
  </div>
</template>

<script>
import closeBoxesService from "@/services/close-boxes.service";
import CalcPrice from '@/components/CalcPrice.vue';
import { Printd } from 'printd'

export default {
  name: 'pos-format-close-box',
  components: {
    CalcPrice,
  },
  props: {
    data: {
      default: () => ({})
    },
    company: {
      default: () => ({})
    }
  },
  computed: {
    identification_type_letters() {
      // console.log(this.data,this.company);
      let type = this.data.company.identification_type
      let cedula = "";
      if(type === '01') {
        cedula = "Cédula Física"
      } else if(type === '02') {
        cedula = "Cédula Jurídica"
      } else if(type === '03') {
        cedula = "DIMEX"
      } else if(type === '04') {
        cedula = "NITE"
      }
      return cedula
    }
  },
  methods: {
    getCloseBox(id) {
      closeBoxesService.getCloseBox(id)
      .then((res) => {
        // this.data = res.data.data;
        // if (this.data.company != ""){
        //   console.log(this.data);
          this.printPos();
        // }
      })
      .catch((error) => {
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      });
    },
    printPos() {
       const d = new Printd()

      // text or urls is supported
      const styles = [`
        body {
          font-size: 19px;
        }
        @page {
          size:  auto;   
          margin: 1px;
        }
        .company-name: {
          font-size: 20px;
        }
        ul {
          text-align: center;
          list-style: none;
        }
        table {
          width:100%;
          text-align: left;
        }

         tr, td {
          border-top: 1px dashed black;
          padding: 5px;
        }

        .print-totals {
          text-align: right;
        }

        .resolution {
          text-align: center;
          margin-top:8px;
        }

        .thanks-purchase {
          text-align: center;
          margin:10px;
          padding: 5px;
        }

        .key50digits {
          text-align: center;
        }
        .code-qr {
          display: flex;
          justify-content: center;
        }
      `];
      // text or urls is supported
      const scripts = [`
        (() => console.log('Hello from IFrame!'))()
      `]

      // trigger the print dialog on demand
      const printCallback = ({launchPrint, element}) => {
        element.style.display = 'block';
        launchPrint();
      }
      d.print(this.$refs.printArea, styles, scripts, printCallback)
    }
  }
}
</script>

<style>

</style>